import { render, staticRenderFns } from "./peaks-valleys.vue?vue&type=template&id=b7b1e274"
import script from "./peaks-valleys.vue?vue&type=script&lang=js"
export * from "./peaks-valleys.vue?vue&type=script&lang=js"
import style0 from "./peaks-valleys.vue?vue&type=style&index=0&id=b7b1e274&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports